import React from "react";
import { Box, Tabs, Tab, Paper, Typography } from "@mui/material";
// import LabReportTemplates from "./LabTemplates";

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`settings-tabpanel-${index}`}
      aria-labelledby={`settings-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

export default function Settings() {
  const [tab, setTab] = React.useState(1); // default to Report Templates

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Box className="m-t-40" sx={{ p: { xs: 2, md: 4 } }}>
      <Typography variant="h4" sx={{ mb: 2, fontWeight: 700 }}>
        Settings
      </Typography>

      <Paper elevation={1} sx={{ p: 1 }}>
        <Tabs
          value={tab}
          onChange={handleChange}
          aria-label="Settings tabs"
          variant="standard"
          textColor="primary"
          indicatorColor="primary"
        >
          {/* <Tab label="General" id="settings-tab-0" aria-controls="settings-tabpanel-0" /> */}
          <Tab label="Report Templates" id="settings-tab-1" aria-controls="settings-tabpanel-1" />
          {/* <Tab label="Other" id="settings-tab-2" aria-controls="settings-tabpanel-2" /> */}
        </Tabs>

        <TabPanel value={tab} index={1}>
          <Typography variant="body2" color="text.secondary">General settings go here.</Typography>
        </TabPanel>

        <TabPanel value={tab} index={0}>
          {/* <LabReportTemplates /> */}
        </TabPanel>

        <TabPanel value={tab} index={2}>
          <Typography variant="body2" color="text.secondary">Other settings.</Typography>
        </TabPanel>
      </Paper>
    </Box>
  );
}